import { render, staticRenderFns } from "./CheckboxWithFilter.vue?vue&type=template&id=b12cfc2c"
import script from "./CheckboxWithFilter.vue?vue&type=script&lang=js"
export * from "./CheckboxWithFilter.vue?vue&type=script&lang=js"
import style0 from "./CheckboxWithFilter.vue?vue&type=style&index=0&id=b12cfc2c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports